export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 1部の詳細ブロック */}
        <div>
          <div className="text-center mb-12">
            <div className="inline-block bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-2xl mb-6">
              <h3 className="text-3xl lg:text-4xl font-bold">
                1部　「なんであの人はわかってくれないの?」が「そうだったのか!」に変わる
              </h3>
            </div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              占い診断で紐解く、自分と相手の取扱説明書
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-search-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">自己理解が深まる</h4>
                  <p className="text-gray-600">
                    占い診断を通じて、あなたの本質的な性格や特性を明らかにします。自分でも気づかなかった一面を発見できます。
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-group-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">相手の理解が進む</h4>
                  <p className="text-gray-600">
                    相手のタイプを知ることで、なぜそのような行動をするのかが分かります。「わかってくれない」から「そうだったのか!」へ。
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-heart-3-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">関係性が改善する</h4>
                  <p className="text-gray-600">
                    お互いの違いを理解し、より良い関係を築く具体的な方法を学びます。人間関係のストレスが軽減されます。
                  </p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-6 rounded-xl">
                  <img 
                    src="https://public.readdy.ai/ai/img_res/6c6028cedd86bb69c7b31be3cc633390.jpg"
                    alt="理解し合う人々"
                    className="w-full h-48 object-cover object-top rounded-lg mb-4"
                  />
                  <p className="text-sm text-gray-700 font-medium">お互いを理解し合える関係に!</p>
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-6 rounded-xl">
                  <img 
                    src="https://readdy.ai/api/search-image?query=A%20joyful%20scene%20of%20a%20happy%20family%20or%20couple%20smiling%20together%20in%20a%20cozy%20home%20environment%20with%20warm%20lighting%20showing%20improved%20relationships%20and%20better%20communication%20with%20peaceful%20and%20loving%20atmosphere&width=400&height=300&seq=relation2&orientation=portrait"
                    alt="良好な人間関係"
                    className="w-full h-48 object-cover object-top rounded-lg mb-4"
                  />
                  <p className="text-sm text-gray-700 font-medium">人間関係のストレスが軽減!</p>
                </div>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white mb-20">
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">500+</div>
              <div className="text-blue-100">参加者数</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">95%</div>
              <div className="text-blue-100">満足度</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">80%</div>
              <div className="text-blue-100">関係改善報告</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">10年</div>
              <div className="text-blue-100">開催実績</div>
            </div>
          </div>

          {/* 2部の詳細ブロック */}
          <div>
            <div className="text-center mb-12">
              <div className="inline-block bg-gradient-to-r from-teal-600 to-blue-600 text-white px-8 py-4 rounded-2xl mb-6">
                <h3 className="text-3xl lg:text-4xl font-bold">
                  2部　ビジョンマップとは
                </h3>
              </div>
              <p className="text-xl text-gray-700 font-semibold mb-8">
                あなたのなりたい姿、実現したい夢を写真や文字で一枚の絵に視覚化したもの
              </p>

              {/* ビジョンマップの画像 */}
              <div className="max-w-4xl mx-auto mb-12">
                <div className="bg-gradient-to-br from-teal-50 to-blue-50 p-6 rounded-2xl">
                  <img 
                    src="https://static.readdy.ai/image/41be8099d52dd4fa30a2ec6c94e7a004/1acfa562bdfc70a4f48cbf55b80d519b.png"
                    alt="ビジョンマップの例"
                    className="w-full h-auto object-cover object-top rounded-lg shadow-lg"
                  />
                </div>
              </div>

              {/* 新しい導入テキスト */}
              <div className="max-w-3xl mx-auto mb-12">
                <div className="bg-gradient-to-br from-teal-50 to-blue-50 p-8 rounded-2xl">
                  <div className="space-y-4 text-gray-700 text-lg">
                    <p className="font-medium">「やりたいことはあるけれど、、、」</p>
                    <p className="font-medium">「そもそも私の夢ってなんだろう？」</p>
                    <p className="text-xl font-bold text-teal-700 mt-6">
                      そんな想いを、たった1日でスッキリさせる<br />
                      世界にひとつだけの"人生の地図"づくり セミナーです✨
                    </p>
                  </div>
                </div>
              </div>

              {/* ビジョンマップとは？ */}
              <div className="max-w-4xl mx-auto mb-12">
                <div className="bg-white p-8 rounded-2xl shadow-lg">
                  <h4 className="text-2xl font-bold text-gray-900 mb-6 flex items-center justify-center gap-2">
                    <i className="ri-star-line text-teal-600"></i>
                    ビジョンマップとは？
                  </h4>
                  <p className="text-lg text-gray-700 leading-relaxed mb-4">
                    未来の理想や願いを、写真・言葉・イメージで1枚にまとめる、<br />
                    潜在意識にアクセスする"夢の地図"。
                  </p>
                  <p className="text-lg text-gray-700 leading-relaxed">
                    思考で考える目標ではなく、<br />
                    ハートから湧き上がる<strong className="text-teal-600">"本当に望む未来"</strong> に出会えます。
                  </p>
                </div>
              </div>

              {/* 新しい画像を追加 */}
              <div className="max-w-4xl mx-auto mb-12">
                <div className="bg-gradient-to-br from-teal-50 to-blue-50 p-6 rounded-2xl">
                  <img 
                    src="https://static.readdy.ai/image/41be8099d52dd4fa30a2ec6c94e7a004/d971db4e08662f71f91a0085a8513eaf.png"
                    alt="ビジョンマップの詳細"
                    className="w-full h-auto object-cover object-top rounded-lg shadow-lg"
                  />
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-2xl p-8 lg:p-12 shadow-xl mb-12">
              <div className="grid md:grid-cols-2 gap-8 mb-10">
                {/* 左側：こんな方におすすめ */}
                <div className="bg-white p-8 rounded-xl shadow-lg">
                  <h5 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-teal-600"></i>
                    こんな方におすすめ
                  </h5>
                  <div className="space-y-4">
                    <div className="flex items-start gap-3">
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                        <i className="ri-checkbox-circle-fill text-xl text-teal-600"></i>
                      </div>
                      <p className="text-gray-700">ビジョンを明確にしたい方</p>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                        <i className="ri-checkbox-circle-fill text-xl text-teal-600"></i>
                      </div>
                      <p className="text-gray-700">夢を実現したい方</p>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                        <i className="ri-checkbox-circle-fill text-xl text-teal-600"></i>
                      </div>
                      <p className="text-gray-700">自分の本心が望むものを知りたい方</p>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                        <i className="ri-checkbox-circle-fill text-xl text-teal-600"></i>
                      </div>
                      <p className="text-gray-700">人生を変えたい方</p>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                        <i className="ri-checkbox-circle-fill text-xl text-teal-600"></i>
                      </div>
                      <p className="text-gray-700">新しい自分に出会いたい方</p>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                        <i className="ri-checkbox-circle-fill text-xl text-teal-600"></i>
                      </div>
                      <p className="text-gray-700">グループのパワーで前に進みたい方</p>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                        <i className="ri-checkbox-circle-fill text-xl text-teal-600"></i>
                      </div>
                      <p className="text-gray-700">心を整えて、新年を迎えたい方</p>
                    </div>
                  </div>
                </div>

                {/* 右側：お客様の声 */}
                <div className="bg-white p-8 rounded-xl shadow-lg">
                  <h5 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                    <i className="ri-chat-quote-line text-teal-600"></i>
                    お客様の声（一部抜粋）
                  </h5>
                  <div className="space-y-4">
                    <div className="bg-gradient-to-br from-teal-50 to-blue-50 p-4 rounded-lg">
                      <p className="text-sm text-gray-700">「理想のマップができてワクワク。毎日眺めて潜在意識に落とし込んでいます！」</p>
                    </div>
                    <div className="bg-gradient-to-br from-teal-50 to-blue-50 p-4 rounded-lg">
                      <p className="text-sm text-gray-700">「写真を貼るだけなのに、自分の"本音"が見えてきて驚きました」</p>
                    </div>
                    <div className="bg-gradient-to-br from-teal-50 to-blue-50 p-4 rounded-lg">
                      <p className="text-sm text-gray-700">「憧れている女性像が明確になり、今年やりたいことがハッキリしました」</p>
                    </div>
                    <div className="bg-gradient-to-br from-teal-50 to-blue-50 p-4 rounded-lg">
                      <p className="text-sm text-gray-700">「他の人のマップからも気づきがたくさん。グループってすごい！」</p>
                    </div>
                    <div className="bg-gradient-to-br from-teal-50 to-blue-50 p-4 rounded-lg">
                      <p className="text-sm text-gray-700">「完成したマップを待ち受けにすると叶いやすいと実感しました」</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 他とは違う、このセミナーのこだわり */}
              <div className="bg-white p-8 rounded-xl shadow-lg mb-10">
                <h5 className="text-2xl font-bold text-gray-900 mb-8 text-center flex items-center justify-center gap-2">
                  <i className="ri-star-line text-teal-600"></i>
                  他とは違う、このセミナーのこだわり
                </h5>
                <div className="grid md:grid-cols-3 gap-6">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-brain-line text-3xl text-teal-600"></i>
                    </div>
                    <h6 className="font-bold text-gray-900 mb-3">① 潜在意識にアクセス</h6>
                    <p className="text-sm text-gray-600">
                      思考の目標ではなく、<br />
                      あなたのハートが本当に望む未来を引き出します。
                    </p>
                  </div>
                  <div className="text-center">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-heart-pulse-line text-3xl text-blue-600"></i>
                    </div>
                    <h6 className="font-bold text-gray-900 mb-3">② 心のクリーニング</h6>
                    <p className="text-sm text-gray-600">
                      心から夢に向かっていけるように<br />
                      心を整えて、新しいビジョンを迎え入れるスペースを空けていきます。
                    </p>
                  </div>
                  <div className="text-center">
                    <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-rocket-line text-3xl text-purple-600"></i>
                    </div>
                    <h6 className="font-bold text-gray-900 mb-3">③ ビジョンが叶いやすくなる仕組み</h6>
                    <p className="text-sm text-gray-600">
                      視覚化 → 毎日の"意識づけ" → グループパワー<br />
                      これらが重なり、叶うスピードが加速します。
                    </p>
                  </div>
                </div>
              </div>

              {/* 講師よりメッセージ */}
              <div className="bg-gradient-to-br from-teal-600 to-blue-600 p-8 rounded-xl shadow-lg text-white">
                <h5 className="text-2xl font-bold mb-6 text-center flex items-center justify-center gap-2">
                  <i className="ri-message-3-line"></i>
                  講師よりメッセージ
                </h5>
                <div className="grid md:grid-cols-2 gap-8 items-center">
                  <div className="order-2 md:order-1">
                    <div className="space-y-4">
                      <p className="text-lg leading-relaxed">
                        私は20年近くビジョンマップを作ってきましたが、<br />
                        描いてきたビジョンの多くが実現してきました。
                      </p>
                      <p className="text-lg leading-relaxed">
                        結婚後は夫婦のビジョンマップも作り、<br />
                        お互いを応援しながら共に叶えています💕
                      </p>
                      <p className="text-xl font-bold mt-6">
                        あなたの潜在意識が導く"未来のヒント"。<br />
                        一緒に見つけにいきましょう✨
                      </p>
                    </div>
                  </div>
                  <div className="order-1 md:order-2">
                    <div className="bg-white/10 backdrop-blur-sm p-4 rounded-xl">
                      <img 
                        src="https://static.readdy.ai/image/41be8099d52dd4fa30a2ec6c94e7a004/13d82dd2b730c4cd3701eff2a15a44f3.png"
                        alt="講師のビジョンマップ"
                        className="w-full h-auto object-cover object-top rounded-lg"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ビジョンマップの作り方 */}
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h5 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                <i className="ri-palette-line text-teal-600"></i>
                ビジョンマップの作り方
              </h5>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-image-line text-3xl text-teal-600"></i>
                  </div>
                  <h6 className="font-bold text-gray-900 mb-2">1. 写真を選ぶ</h6>
                  <p className="text-sm text-gray-600">
                    直感に従って、雑誌やカタログから、あなたの夢や目標を表す写真を選びます
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-scissors-line text-3xl text-blue-600"></i>
                  </div>
                  <h6 className="font-bold text-gray-900 mb-2">2. 切り貼りする</h6>
                  <p className="text-sm text-gray-600">
                    写真や文字を一枚の紙に自由に貼り付けます
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-eye-line text-3xl text-purple-600"></i>
                  </div>
                  <h6 className="font-bold text-gray-900 mb-2">3. 毎日見る</h6>
                  <p className="text-sm text-gray-600">
                    目に触れる場所に置いて、毎日眺めることで実現化が加速します
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
